import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AuthenticationService } from '../../services/authentication.service';
import { AuthenticationFormFactory } from '../../mappers/authentication-form.factory';
import { ActivatedRoute, Router } from '@angular/router';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { VerifyDto } from '../../dtos/verify.dto';
import { AuthenticationMapper } from '../../mappers/autentication.mapper';
import { ErrorService } from '../../../../core/services/error.service';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { MemoryService } from '../../../../core/services/memory.service';

@Component({
  selector: 'app-set-password',
  imports: [
    MatFormFieldModule,
    ReactiveFormsModule,
    MatCardModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    TranslocoPipe
  ],
  templateUrl: './set-password.component.html',
  styleUrl: './set-password.component.scss'
})
export class SetPasswordComponent implements OnInit{
  setPasswordForm!: FormGroup;
  urlParameter?: string;

  error?: string
  hidePassword: boolean = true;
  hidePasswordRepeat: boolean = true;

  constructor(private authenticationService: AuthenticationService, private memoryService: MemoryService, private translocoService: TranslocoService, private fb: FormBuilder, private activatedRoute: ActivatedRoute, private router: Router, private errorService: ErrorService) {
  }

  ngOnInit() {
    this.memoryService.customerId = this.activatedRoute.snapshot.queryParams['customerId'];

    this.setPasswordForm = AuthenticationFormFactory.createSetPasswordForm(this.fb)

    this.urlParameter = this.activatedRoute.snapshot.queryParams['verificationCode'];
    if (this.urlParameter) {
      this.setPasswordForm.patchValue({verificationCode: this.urlParameter});
    }
  }

  togglePasswordVisibility(){
    this.hidePassword = !this.hidePassword;
  }

  togglePasswordRepeatVisibility(){
    this.hidePasswordRepeat = !this.hidePasswordRepeat;
  }

  setPassword(){
    if(this.setPasswordForm.invalid){
      this.setPasswordForm.markAllAsTouched();
      return;
    }

    if (this.setPasswordForm.value.password != this.setPasswordForm.value.passwordRepeat) {
      this.error = this.translocoService.translate('error.password_mismatch');
      return
    }

    if (this.setPasswordForm.value.password.length < 8) {
      this.error = this.translocoService.translate('error.password_tooshort');
      return
    }

    let verifyDto: VerifyDto = AuthenticationMapper.toVerifyDto(this.setPasswordForm.value)
    this.authenticationService.verify(verifyDto).subscribe({
      next: () => {
        this.router.navigate(['/login']);
      },
      error: (error) => {
        this.error = this.errorService.handleError(error);
      }
    })
  }
}
